import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Typography } from '@mui/material';

export const Banner = ({ text, icon, severity = 'info', children }) => {
  return (
    text && (
      <Alert icon={icon ? <FontAwesomeIcon icon={icon} /> : undefined} severity={severity} action={children}>
        <Typography component={'span'}>{text}</Typography>
      </Alert>
    )
  );
};
